function inputFile() {

    $(document).on('click', '._js-file-button', function(){
        let inputFile  = $(this).parents('.input-file').find('._js-input-file');

        inputFile.trigger('click');
        inputFile.on('change', function(){
            let inputText   = $(this).parents('.input-file').find('._js-input-text');

            if ( $(this).val ) {
                let uploadedFileName = this.files[0].name;
                inputText.val(uploadedFileName);
            } else {
                inputText.val('');
            }
        });
    });
}